import { Component, EventEmitter, Input, Output } from "@angular/core";
import {OrderContentService} from "../../../../../services/orderContentService";
import {OrderContent} from "../../../../../objects/orders/orderContent";
import {OrderStatus} from "../../../../../objects/orders/orderStatus";
import { Order } from "../../../../../objects/orders/order";
import { CBP3461 } from "../../../../../objects/documents/CBP3461";
/**
 * Created by alex.y on 10/2/2017.
 */

@Component({
    selector: 'order-prep-doc-tab',
    templateUrl: 'PreparingDocTab.component.html',
    moduleId: module.id.toString()
})
export class PreparingDocTabComponent {
    @Input()
    public orderContent: OrderContent;

    @Input()
    public tabNumber: number;

    @Input()
    public isReadOnly: boolean = false;

    @Input()
    public showTitle: boolean = true;

    @Input()
    public showContinue: boolean = false;

    @Input()
    public order: Order;

    @Output()
    public completeOrderEvent: EventEmitter<boolean> = new EventEmitter();

    constructor(public orderContentService: OrderContentService) {

    }

    public saveComment(): void {
        if(this.isReadOnly)
            return;

        let arr = new Array<OrderContent>();
        arr.push(this.orderContent);

        this.orderContentService.modify(arr).then((resp: any) => {
            if(!resp.Data || resp.Data.length == 0)
                return;

            if(resp.Data[0].OrderStatus == this.tabNumber)
                this.orderContent = resp.Data[0];
        });

    }

    public getTitle(): string {
        switch (this.tabNumber) {
            case(OrderStatus.Quoted) :
                return "Payment";
            case(OrderStatus.Paid) :
                return "Prepared Documents";
            case(OrderStatus.PrepareDoc) :
                return "Sent to customs";
            case(OrderStatus.SentToCustom) :
                return "Customs released";
            case(OrderStatus.CustomReleased) :
            case(OrderStatus.BorderCrossed) :
            case(OrderStatus.Closed) :
                return "Case closed";
        }

    }


}


// WEBPACK FOOTER //
// ./app/components/Managment/orderManagement/orderData/tabs/preparingDocTab.component.ts